module.exports = __webpack_public_path__ + "static/media/take_pic_finity.c4442139.svg";